import { Album } from '@/models/album';
import { GalleryItem } from './gallery-item';
import { GallerySkeleton } from './gallery-skeleton';

type GalleryProps = {
    albums: Album[];
};

export const Gallery = ({ albums }: GalleryProps) => {
    return (
        <div className="grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-6">
            {albums.map((album) => (
                <GalleryItem key={album.id} albumId={album.id} />
            ))}
        </div>
    );
};

Gallery.Skeleton = GallerySkeleton;
